import axios from 'axios';
import { setAlert } from './alert';
import {
    GET_CATEGORIES, CATEGORY_ERROR, ADD_CATEGORY, GET_CATEGORY, UPDATE_CATEGORY
} from './types';

import { base_url } from './constants';

axios.defaults.baseURL = base_url;

//GET Categories
export const getCategories = () => async dispatch => {
    try {
        const res = await axios.get('/api/categories/');
        dispatch({ type: GET_CATEGORIES, payload: res.data })
    } catch (err) {
        dispatch({
            type: CATEGORY_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status }
        });
    }
}

export const getCurrentCategory = id => async dispatch => {
    try {
        const res = await axios.get(`/api/categories/${id}`);

        dispatch({ type: GET_CATEGORY, payload: res.data });
    } catch (err) {
        dispatch({
            type: CATEGORY_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status }
        });
    }
}

// Create category
export const createCategory = formData => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    try {
        const res = await axios.post('/api/categories/create', formData, config);
        dispatch({
            type: ADD_CATEGORY,
            payload: res.data
        });
        dispatch(setAlert('Category Created', 'success'));
    } catch (err) {
        const errors = err.response.data.errors;
        console.log(errors);
        if (errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }
        dispatch({
            type: CATEGORY_ERROR,
        });
    }
}

// Update category
export const updateCategory = (id, formData) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    try {
        const res = await axios.put('/api/categories/update/' + id, formData, config);
        dispatch({
            type: UPDATE_CATEGORY,
            payload: res.data
        });
        dispatch(setAlert('Category Updated', 'success'));
    } catch (err) {
        const errors = err.response.data.errors;
        console.log(errors);
        if (errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }
        dispatch({
            type: CATEGORY_ERROR,
        });
    }
}